import { Wallet } from 'lucide-react';
import Table from '@/components/table/components/Table.tsx';
import EmptyTable from '@/components/table/components/EmptyTable.tsx';
import { expensesApiQueryKeys } from '@/features/dashboard/expenses/api/expensesApi.queryKeys.ts';
import expensesApi from '@/features/dashboard/expenses/api/expensesApi.ts';
import useExpenseRowActions from '@/features/dashboard/expenses/hooks/useExpenseRowActions.tsx';

const GlobalExpensesTable = () => {
  // Globalny wiersz niesie wyjazd w `tour`, bo kolumna „Nazwa wyjazdu” jest płaska.
  const { rowContextMenuItems, expenseRowModals } = useExpenseRowActions({
    tourIdOf: (row) => row.tour.id,
  });

  return (
    <>
      <Table
        queryKey={expensesApiQueryKeys.global()}
        fetchData={expensesApi.getAllGlobal}
        fetchTableDef={expensesApi.getGlobalTableDefinition}
        rowContextMenuItems={rowContextMenuItems}
        emptyDataComponent={
          <EmptyTable
            title="Brak wydatków"
            description="Zaplanuj wydatek na wyjeździe albo zakwalifikuj przelew z wyciągu."
            icon={<Wallet />}
          />
        }
      />

      {expenseRowModals}
    </>
  );
};

export default GlobalExpensesTable;
